<div class="flex gap-10 h-full overflow-hidden">
  <app-ssb-konfig-search style="width:400px" />
  <div class="flex-1 h-full">
    <app-ssb-konfig-result />
  </div>
</div>
